import {action, observable, makeObservable, computed} from 'mobx';

class DispatchStore {
  @observable loading = false;
  @observable
  isUploading = false;
  @observable
  formMediaUrl = '';
  @observable
  formFeedbackText = '';

  @observable mediaUpdated = false;
  @observable textUpdated = false;

  @observable selectedLineId = null;
  @observable selectedDispatchTypeId = null;
  @observable selectedMachineId = null;

  @action setSelectedLine = (lineId, dispatchMachinesQuery) => {
    if (this.selectedLineId === lineId) {
      return;
    }
    this.selectedLineId = lineId;
    this.selectedMachineId = null;
    dispatchMachinesQuery({
      variables: {
        lineId
      }
    });
  };
  @action setSelectedDispatchType = dispatchType => (this.selectedDispatchTypeId = dispatchType);
  @action setSelectedMachine = machine => (this.selectedMachineId = machine);

  maxFeedbackLength = 300;

  @computed
  get feedbackText() {
    return this.textUpdated
      ? this.formFeedbackText
      : this.checklistStore.feedbackForStep(this.instructionPageStore.activeStepId) || '';
  }

  @computed
  get mediaUrl() {
    return this.mediaUpdated
      ? this.formMediaUrl
      : this.checklistStore.mediaUrlForStep(this.instructionPageStore.activeStepId);
  }

  @action
  setLoading = loading => (this.loading = loading);

  @action
  reset = () => {
    this.isUploading = false;
    this.formMediaUrl = '';
    this.formFeedbackText = '';
    this.mediaUpdated = false;
    this.textUpdated = false;
    this.loading = false;
    this.selectedLineId = null;
    this.selectedDispatchTypeId = null;
    this.selectedMachineId = null;
  };

  @computed
  get canOpenDispatch() {
    return this.feedbackText && this.selectedLineId && this.selectedDispatchTypeId && this.selectedMachineId;
  }

  @action
  createDispatch = async dispatchMutation => {
    this.setLoading(true);

    const {currentGuideVersionId, activeStepId} = this.instructionPageStore;
    const {updateChecklist, checklist} = this.checklistStore;

    try {
      await dispatchMutation({
        variables: {
          dispatchContents: {
            stepId: activeStepId,
            guideVersionId: currentGuideVersionId,
            linkToCheck: window.location.href,
            feedback: this.feedbackText,
            mediaUrl: this.mediaUrl,
            checklistTemplateOptionId: checklist[activeStepId]?.optionId ?? null,
            dispatchTypeId: this.selectedDispatchTypeId,
            dispatchMachineId: this.selectedMachineId
          }
        }
      });
      updateChecklist(activeStepId, {
        checkEscalated: true,
        feedbackText: this.feedbackText,
        mediaUrl: this.mediaUrl
      });
      this.reset();
    } finally {
      this.setLoading(false);
    }
  };

  constructor() {
    makeObservable(this);
  }

  @action
  setIsUploading = isUploading => {
    this.isUploading = isUploading;
  };

  @action
  setMediaUrl = mediaUrl => {
    this.formMediaUrl = mediaUrl;
    this.mediaUpdated = true;
  };

  @action
  setFeedbackText = feedbackText => {
    if (feedbackText.length > this.maxFeedbackLength) {
      feedbackText = feedbackText.slice(0, this.maxFeedbackLength);
    }

    this.formFeedbackText = feedbackText;
    this.textUpdated = true;
  };

  setStores = ({checklist, instructionPage}) => {
    this.instructionPageStore = instructionPage;
    this.checklistStore = checklist;
  };
}
export default DispatchStore;
